import { GameUpdateState } from '../game-update';
import { Graphics } from 'src/app/display/graphics';
import { World } from 'src/app/model/world';
import { ConsoleScreen } from 'src/app/console/console-screen';
import { ScreenDisplay } from 'src/app/display/screen-display';
import { Point, equals } from 'src/app/math/point';
import { Size } from 'src/app/math/size';
import { ConsoleDraw, BoxStyleType } from 'src/app/console/console-draw';
import { Rectangle } from 'src/app/math/rectangle';
import { vector } from 'src/app/math/vector';
import { Ship } from 'src/app/model/ship';

export class ReadoutUpdate extends GameUpdateState {
  private consoleSize: Size
  private consoleDraw: ConsoleDraw
  private screen: ConsoleScreen
  private screenDisplay: ScreenDisplay

  private consoleSize2: Size
  private consoleDraw2: ConsoleDraw
  private screen2: ConsoleScreen
  private screenDisplay2: ScreenDisplay

  constructor(readonly origin: Point, readonly make: Phaser.GameObjects.GameObjectCreator) {
    super()
    this.consoleSize = new Size(72, 42)
    this.screen = new ConsoleScreen(this.consoleSize)
    this.screenDisplay = new ScreenDisplay('font-0', new Size(8, 16), origin, this.consoleSize, this.make)
    this.consoleDraw = new ConsoleDraw(this.screen)

    this.consoleSize2 = new Size(36, 42)
    this.screen2 = new ConsoleScreen(this.consoleSize2)
    this.screenDisplay2 = new ScreenDisplay('font-2', new Size(16, 16), origin, this.consoleSize2, this.make)
    this.consoleDraw2 = new ConsoleDraw(this.screen2)
  }

  update(world: World, elapsed: number): World {
    this.screen2.bg = 0x444444
    this.screen2.fg = 0xBBBBBB
    this.consoleDraw2.drawBox(new Rectangle(new Point(0, 0), this.consoleSize2), BoxStyleType.DOUBLE)
    this.screen2.bg = 0x000000

    const actionsX = this.consoleSize2.width - 9
    this.screen2.writeAt(new Point(actionsX, 1), "Shields")
    this.screen2.writeAt(new Point(actionsX, 2), "Overload")
    this.screen2.writeAt(new Point(actionsX, 3), "Engines")
    this.screen2.writeAt(new Point(actionsX, 4), "Turn")
    this.screen2.writeAt(new Point(actionsX, 5), "Evade")

    // this.screen2.writeAt(new Point(1, 1), "0 1 2 3 4 5 6 7 8 9")
    // this.screen.writeAt(new Point(1, 2), "01  23  45  67  89")
    const hullY = 1
    const hullLabel = `Hull:`
    this.screen2.writeAt(new Point(1, hullY), hullLabel)
    if (world.ship.hullPoints <= 0) {
      this.screen.fg = 0xFF0000
      this.screen.bg = 0x000000
    } else {
      this.screen.fg = 0xFFFFFF
      this.screen.bg = 0x000000
    }
    this.screen.writeAt(new Point(12, hullY), `${world.ship.hullPoints}`.padStart(3))
    this.screen.fg = 0xFFFFFF
    this.screen.bg = 0x000000

    const shields = world.ship.shields
    const shieldsY = hullY + 1
    this.screen2.writeAt(new Point(1, shieldsY), 'Shields')

    this.consoleDraw.drawBox(new Rectangle(new Point(2, shieldsY+1), new Size(8,5)), BoxStyleType.SINGLE)

    this.screen2.writeCharCode(15, 3, shieldsY+3)
    if (shields[0] <= 0) {
      this.screen.fg = 0xFF0000
      this.screen.bg = 0x000000
    } else {
      this.screen.fg = 0xFFFFFF
      this.screen.bg = 0x000000
    }
    this.screen.writeAt(new Point(5, shieldsY+2), `${shields[0]}`.padStart(2, `0`))
    if (shields[1] <= 0) {
      this.screen.fg = 0xFF0000
      this.screen.bg = 0x000000
    } else {
      this.screen.fg = 0xFFFFFF
      this.screen.bg = 0x000000
    }
    this.screen.writeAt(new Point(3, shieldsY+3), `${shields[1]}`.padStart(2, `0`))
    if (shields[3] <= 0) {
      this.screen.fg = 0xFF0000
      this.screen.bg = 0x000000
    } else {
      this.screen.fg = 0xFFFFFF
      this.screen.bg = 0x000000
    }
    this.screen.writeAt(new Point(7, shieldsY+3), `${shields[3]}`.padStart(2, `0`))

    if (shields[2] <= 0) {
      this.screen.fg = 0xFF0000
      this.screen.bg = 0x000000
    } else {
      this.screen.fg = 0xFFFFFF
      this.screen.bg = 0x000000
    }
    this.screen.writeAt(new Point(5, shieldsY+4), `${shields[2]}`.padStart(2, `0`))


    this.screen.fg = 0xFFFFFF
    this.screen.bg = 0x000000

    // this.screen2.writeAt(new Point(2, 0), "Weapons")
    // this.screen.writeAt(new Point(2, 2), "Weapons")

    const weaponsY = shieldsY + 7
    this.screen.writeAt(new Point(2, weaponsY), "Weapons")
    this.screen.writeAt(new Point(13, weaponsY), `Rng`)
    this.screen.writeAt(new Point(17, weaponsY), `AD`)
    this.screen.writeAt(new Point(20, weaponsY), `Load`)
    this.screen.writeAt(new Point(25, weaponsY), `Hit`)
    this.screen.writeAt(new Point(29, weaponsY), `Auto`)
    const p0 = world.snap(world.pointer)
    world.ship.weapons.forEach( (weapon, i) => {
      const target = world.enemies.find(enemy => equals(p0, enemy.position));
      if (target !== undefined && weapon.canAttack(world.ship, target)) {
        this.screen.fg = 0xFF0000
        this.screen.bg = 0x000000
      } else {
        this.screen.fg = 0xFFFFFF
        this.screen.bg = 0x000000
      }
      const arcString = weapon.arc.map(a => `${a}`).join(' ')
      const weaponText = `${weapon.name} - ${weapon.range} - ${weapon.attack} - ${arcString}`
      this.screen.writeAt(new Point(3, weaponsY+1+i), `${weapon.name}`)
      this.screen.writeAt(new Point(13, weaponsY+1+i), `${weapon.range}`.padStart(3))
      this.screen.writeAt(new Point(18, weaponsY+1+i), `${weapon.attack}`)
      this.screen.writeAt(new Point(21, weaponsY+1+i), `${weapon.charge}`)
      this.screen.writeAt(new Point(25, weaponsY+1+i), `${weapon.hits}`.padStart(2))
      this.screen.writeAt(new Point(29, weaponsY+1+i), `${weapon.auto}`.padStart(2))
    })

    this.screen.fg = 0xFFFFFF
    this.screen.bg = 0x000000
    // const shieldsString = world.ship.shields.map(s => `${s}`).join(' - ')
    // const shieldsText = `Shields: ${shieldsString}`
    // this.screen.writeAt(new Point(3, 3), shieldsText)

    const updateText =  `Elapsed: [` + `${Math.round(world.deltaTime)}]`.padStart(5, '0')
    this.screen.writeAt(new Point(1, 36), updateText)

    const targetName =  findEnemy(world, p0)?.name ?? world.ship.targetLock?.name ?? 'None'
    const targetText =  `Target: [${targetName}]`.padEnd(30, ' ')
    this.screen.writeAt(new Point(1, 38), targetText)
    if (targetName !== 'None') {
      const target =  findEnemy(world, p0) ?? world.ship.targetLock
      if (target !== undefined) {

        const targetHullText =  `Hull: [${target.hullPoints}]`.padEnd(5, ' ')
        this.screen.writeAt(new Point(1, 39), targetHullText)
        const targetShieldsText =  `Shields: [${target.shields[0]}/${target.shields[1]}/${target.shields[2]}/${target.shields[3]}]`.padEnd(5, ' ')
        this.screen.writeAt(new Point(1, 40), targetShieldsText)
      }
    } else {
      const targetHullText =  ``.padEnd(25, ' ')
      this.screen.writeAt(new Point(1, 39), targetHullText)
      const targetShieldsText =  ``.padEnd(25, ' ')
      this.screen.writeAt(new Point(1, 40), targetShieldsText)
    }

    const bottomY = 40

    const turnCount = `${world.turnCount}`.padStart(3, '0')
    const turnCountText = `Turn Count: [${turnCount}]`
    this.screen.writeAt(new Point(69-turnCountText.length, bottomY-3), turnCountText)

    const quadrant = world.ship.quadrant(world.pointer)
    const quadrantText = `Quadrant: [${quadrant}]`
    this.screen.writeAt(new Point(69-quadrantText.length, bottomY-2), quadrantText)
    const v = vector(world.pointer, world.ship.position)
    const distanceText = `[${toCoordStr(v.length())}]`
    this.screen.writeAt(new Point(69-distanceText.length, bottomY-1), distanceText)
    const pointerText = `[${toCoordStr(world.pointer.x)}.${toCoordStr(world.pointer.y)}]`
    this.screen.writeAt(new Point(69-pointerText.length, bottomY), pointerText)
    //const pointerText2 = `Cursor: [${Math.floor(this.screenPointer.x)}.${Math.floor(this.screenPointer.y)}]     `
    //this.screen.writeAt(new Point(3, 21), pointerText2)
    // const pointerText3 = `Cursor: [${Math.floor(p0.x)}.${Math.floor(p0.y)}]     `
    // this.screen.writeAt(new Point(3, 22), pointerText3)

    return world
  }

  draw(world: World, graphics: Graphics): void {
    this.screenDisplay.draw(this.screen)
    this.screenDisplay2.draw(this.screen2)
  }
}

function findEnemy(world: World, p: Point): Ship | undefined {
  return world.enemies.find(enemy => equals(p, enemy.position));
}

function toCoordStr(n: number): string {
  const sign = toSign(n)
  const str1 = `${Math.floor(Math.abs(n))}`.padStart(3, '0')
  return `${sign}${str1}`
}

function toSign(n: number): string {
  switch (Math.sign(n)) {
    case -1: return '-'
    case 0: return '+'
    case +1: return '+'
    default: return ' '
  }
}